import { useTranslation } from '@web_opxp/features';
import map from 'lodash/map';
import React from 'react';
import { connect } from 'react-redux';
import { legalsRequestAction } from '../store/actions';
import * as Selectors from '../store/selectors';
import { CountriesMap, Country, EArticleAlias } from '../types';
import ContinentGroup from './ContinentGroup';
import './CountriesSelectView.scss';

interface OwnProps {
  type: EArticleAlias;
}

interface CountriesSelectViewProps extends OwnProps {
  countries: CountriesMap;
  mostCommon: Country[];
  onCountrySelect: (type: EArticleAlias, id: string) => void;
}

export const CountriesSelectViewFC: React.FC<CountriesSelectViewProps> = ({
  countries,
  mostCommon,
  type,
  onCountrySelect,
}) => {
  const selectHandler = (id: string) => onCountrySelect(type, id);
  const { t } = useTranslation();
  const continentMap = map(countries, (countriesList, continent) => (
    <ContinentGroup key={continent} continent={continent} countries={countriesList} onSelect={selectHandler} />
  ));
  return (
    <>
      <h1 className="countries-header">{t(`TOU.${type}.Title`)}</h1>
      <p className="countries-intro">{t('TOU.Intro')}</p>
      <ContinentGroup
        key={`most-common-countries`}
        countries={mostCommon}
        label={t(`TOU.MostCommon`)}
        onSelect={selectHandler}
      />
      {continentMap}
    </>
  );
};

const mapStateToProps = (state: Selectors.IState) => {
  const countries = Selectors.getCountries(state);
  const mostCommon = Selectors.getMostCommonList(state);
  return {
    countries,
    mostCommon,
  };
};

const mapDispatchToProps = {
  onCountrySelect: legalsRequestAction,
};

const CountriesSelectView = connect(mapStateToProps, mapDispatchToProps)(CountriesSelectViewFC);

export default CountriesSelectView;
